﻿import WOW from './wow.min.js'

$(document).ready(function () {
    // Back to top button-------------------
    // 初始隱藏按鈕
    $('.ytlee-back-to-top').hide();

    // 監聽滾動事件，控制按鈕顯示或隱藏
    $(window).scroll(function () {
        if ($(this).scrollTop() > 0) {
            // 如果按鈕隱藏，則顯示並添加漸進動畫
            if ($('.ytlee-back-to-top').is(':hidden')) {
                $('.ytlee-back-to-top').fadeIn('slow').removeClass('d-none');
            }
        } else {
            // 如果按鈕顯示，則隱藏並添加漸進動畫
            if ($('.ytlee-back-to-top').is(':visible')) {
                $('.ytlee-back-to-top').fadeOut('slow', function () {
                    $(this).addClass('d-none');
                });
            }
        }
    });

    // 點擊按鈕後立即滾動到頂部
    $('.ytlee-back-to-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 0);
        return false;
    });

    // 控制搜尋框-------------------
    $('#search_btn').on('click', function () {
        const $searchInput = $('#search');

        // 僅在大螢幕執行展開/搜尋功能
        if (window.innerWidth >= 992) {
            if (!$searchInput.hasClass('active')) {
                // 搜尋框未展開，執行展開
                $searchInput.addClass('active').focus();
            }
            else if ($searchInput.val().trim() !== '') {
                // 搜尋框展開且有文字，執行搜尋
                performSearch($searchInput.val());
            }
            else {
                // 搜尋框展開但無文字，執行收起
                $searchInput.removeClass('active');
            }
        }
    });

    // 點擊外部收起搜尋框（僅大螢幕）
    $(document).on('click', function (event) {
        const $searchInput = $('#search');
        const $searchBtn = $('#search_btn');
        if (
            window.innerWidth >= 992 &&
            !$searchInput.is(event.target) &&
            !$searchBtn.is(event.target) &&
            !$searchBtn.has(event.target).length
        ) {
            $searchInput.removeClass('active');
        }
    });

    // 按下 ESC 收起搜尋框（僅大螢幕）
    $(document).on('keydown', function (event) {
        if (window.innerWidth >= 992 && event.key === 'Escape') {
            $('#search').removeClass('active');
        }
    });

    // 搜尋功能執行
    function performSearch(query) {
        console.log('搜尋中:', query);
        // 在此執行搜尋邏輯，例如導向搜尋頁面或發送請求
        // window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
    // 初始化 WOW動畫-------------------
    new WOW().init();

    // 頁首漢堡圖按鈕-------------------
    $(".nav-btn, .ytlee-nav-btn-cls").on("click", function () {
        $("#navbar_collapse").toggle();

        // 如果選單顯示，隱藏浮動按鈕；否則顯示
        if ($("#navbar_collapse").is(":visible")) {
            $(".floating-sidebar").addClass("hidden");
        } else {
            $(".floating-sidebar").removeClass("hidden");
        }
    });

    // 控制nav選單關閉-------------------
    $(document).on("click", function (event) {
        // 檢查點擊目標是否在模態框內或是漢堡圖內
        if (!$(event.target).closest("#navbar_collapse, .navbar-toggler").length) {
            $("#navbar_collapse").hide();
            $(".floating-sidebar").removeClass("hidden"); // 確保浮動按鈕恢復
        }
    });

    // 移除所有點擊焦點-------------------
    $("button, a").on("click", function () {
        $(this).blur();
    });

    // 控制nav下拉選單-------------------
    //document.querySelectorAll(".dropdown-toggle").forEach((toggle) => {
    //    const dropdownMenu = toggle.nextElementSibling;

    //    if (dropdownMenu && dropdownMenu.classList.contains("dropdown-menu")) {
    //        // 當滑鼠移入主選單 <a> 標籤時，顯示對應的下拉選單
    //        toggle.addEventListener("mouseenter", () => {
    //            dropdownMenu.classList.add("show");
    //        });

    //        // 當滑鼠移入下拉選單時，保持顯示狀態
    //        dropdownMenu.addEventListener("mouseenter", () => {
    //            dropdownMenu.classList.add("show");
    //        });

    //        // 當滑鼠離開主選單 <a> 時，隱藏下拉選單
    //        toggle.addEventListener("mouseleave", () => {
    //            dropdownMenu.classList.remove("show");
    //        });

    //        // 當滑鼠離開下拉選單時，隱藏下拉選單
    //        dropdownMenu.addEventListener("mouseleave", () => {
    //            dropdownMenu.classList.remove("show");
    //        });
    //    }
    //});

    // 控制nav選單手風琴選單accordion的收摺-------------------
    $('#navbar_collapse .accordion-button').on('click', function () {
        var $this = $(this);
        var $target = $($this.attr('data-bs-target'));

        // 如果是大螢幕，實現自訂行為 先隱藏所有摺疊區域
        $('#navbar_collapse .accordion-collapse').not($target).collapse('hide');

        // 切換目前目標區域的摺疊狀態
        $target.collapse('toggle');
    });

    // 將首頁最上面 carousel 更新圖片的地方關掉，看來目前用不到，但 resize 的部分可能需要跟客戶確認他們要的大小再調整

    // 動態切換首頁輪播圖片來源(適應不同視窗視覺效果)-------------------
    //updateCarouselImages();

    // let resizeTimeout;
    // window.addEventListener('resize', () => {
    //     clearTimeout(resizeTimeout);
        //resizeTimeout = setTimeout(updateCarouselImages, 200);
    // });

    //document.addEventListener('DOMContentLoaded', updateCarouselImages);

    // function updateCarouselImages() {
    //     const isMobile = window.innerWidth < 1200; // 判斷是否為 lg 以下螢幕
    //     const carouselImages = document.querySelectorAll('#carousel_indicators img');

    //     carouselImages.forEach((img, index) => {
    //         if (isMobile) {
    //             // 如果為小螢幕，替換為小螢幕專用圖片
    //             img.src = `/img/index_carousel_md_${index + 1}.jpg`;
    //         } else {
    //             // 如果為大螢幕，替換為大螢幕專用圖片
    //             img.src = `/img/index_carousel_lg_${index + 1}.jpg`;
    //         }
    //     });
    // }

    // 圖片放大modal
    $('#image_modal_container').load('/file/image_modal.html');
    $(document).on('click', '.ytlee-hover-img, .ytlee-overlay-icon', function () {
        let imgElement;
        if ($(this).is('.ytlee-hover-img')) {
            imgElement = $(this);
        } else {
            imgElement = $(this).closest('.ytlee-img-container').find('.ytlee-hover-img');
        }
        const imgSrc = imgElement.attr('src');
        const imgAlt = imgElement.attr('alt');
        $('#image_modal img').attr('src', imgSrc).attr('alt', imgAlt);
        $('#image_modal').modal('show');
    });
});

//共用的換頁按鈕邏輯
function initializePagination(data, pageSize, displayCallback, $paginationContainer) {
    let currentPage = 1;

    let maxPageButtons = calculateMaxPageButtons();

    // 根據螢幕大小動態設定 maxPageButtons
    function calculateMaxPageButtons() {
        if ($(window).width() >= 992) { // lg 以上
            return 10;
        }
        else if ($(window).width() >= 576) { // sm ~ md
            return 5;
        }
        else if ($(window).width() >= 337) {
            return 3;
        }
        else { 
            return 1;
        }
    }

    function updatePagination() {
        const totalPages = Math.ceil(data.length / pageSize);

        // 重新計算分頁按鈕範圍
        maxPageButtons = calculateMaxPageButtons();

        // 清空現有的數字按鈕
        $paginationContainer.find('.page-number').remove();

        // 計算分頁按鈕範圍
        let startPage, endPage;

        if (totalPages <= maxPageButtons) {
            // 如果總頁數小於等於 maxPageButtons，顯示所有頁面按鈕
            startPage = 1;
            endPage = totalPages;
        }
        else if (currentPage <= Math.ceil(maxPageButtons / 2)) {
            // 當前頁碼靠近起始位置時，按鈕範圍從 1 開始
            startPage = 1;
            endPage = maxPageButtons;
        }
        else if (currentPage > totalPages - Math.floor(maxPageButtons / 2)) {
            // 當前頁碼靠近結尾時，按鈕範圍固定到最後幾頁
            startPage = totalPages - maxPageButtons + 1;
            endPage = totalPages;
        }
        else {
            // 當前頁碼在中間範圍時，按鈕範圍動態計算
            const halfButtons = Math.floor(maxPageButtons / 2);
            startPage = currentPage - halfButtons;
            endPage = currentPage + halfButtons;

            // 確保按鈕數量限制為 maxPageButtons
            if (endPage - startPage + 1 > maxPageButtons) {
                endPage = startPage + maxPageButtons - 1;
            }
        }

        // 動態生成頁碼按鈕
        for (let i = startPage; i <= endPage; i++) {
            const isActive = i === currentPage ? 'active' : '';
            const pageNumberItem = `
                <li class="page-item page-number ${isActive}">
                    <a class="page-link" href="#">${i}</a>
                </li>
            `;
            $paginationContainer.find('#next_page').parent().before(pageNumberItem);
        }

        // 更新上下頁按鈕的狀態
        $('#first_page').parent().toggleClass('disabled', currentPage === 1);
        $('#prev_page').parent().toggleClass('disabled', currentPage === 1);
        $('#next_page').parent().toggleClass('disabled', currentPage === totalPages);
        $('#last_page').parent().toggleClass('disabled', currentPage === totalPages);

        // 數字按鈕的點擊事件
        $('.page-number').click(function (e) {
            e.preventDefault();
            currentPage = parseInt($(this).text());
            displayCallback(currentPage);
            updatePagination();
            scrollToTop();
        });
    }

    // 分頁按鈕的事件
    $('#first_page').click(function (e) {
        e.preventDefault();
        if (currentPage > 1) {
            currentPage = 1;
            displayCallback(currentPage);
            updatePagination();
            scrollToTop();
        }
    });

    $('#prev_page').click(function (e) {
        e.preventDefault();
        if (currentPage > 1) {
            currentPage--;
            displayCallback(currentPage);
            updatePagination();
            scrollToTop();
        }
    });

    $('#next_page').click(function (e) {
        e.preventDefault();
        const totalPages = Math.ceil(data.length / pageSize);
        if (currentPage < totalPages) {
            currentPage++;
            displayCallback(currentPage);
            updatePagination();
            scrollToTop();
        }
    });

    $('#last_page').click(function (e) {
        e.preventDefault();
        const totalPages = Math.ceil(data.length / pageSize);
        if (currentPage < totalPages) {
            currentPage = totalPages;
            displayCallback(currentPage);
            updatePagination();
            scrollToTop();
        }
    });

    // 初次載入時顯示第一頁資料
    displayCallback(currentPage);
    updatePagination(); // 更新分頁按鈕

    // 當畫面大小改變時，重新計算並更新分頁按鈕
    $(window).resize(function () {
        updatePagination(); // 重新繪製分頁按鈕
    });
}


// function-更新麵包屑導航
function updateBreadcrumb(viewTitle) {
    $('#breadcrumb_now').html(`<span class="h6 text-secondary">${viewTitle}</span>`);
}

function scrollToTop() {
    // 滾動到最上方
    $('#top').get(0).scrollIntoView({ behavior: 'smooth' });
}

window.initializePagination = initializePagination
window.updateBreadcrumb = updateBreadcrumb
window.scrollToTop = scrollToTop
